import * as React from 'react'
import { default as MuiDialog, DialogProps } from '@mui/material/Dialog'

const Dialog: React.FC<React.PropsWithChildren<DialogProps>> = (props) => {
  return <MuiDialog {...props} />
}

export default Dialog
